<template>
    <div>
        <main id="main">

            <section id="featured-services">
                <div class="container">
                    <div class="row">
                        <div class="box" style="height: 5em">
                        </div>
                    </div>
                </div>
            </section><!-- End Featured Services Section -->

            <!-- ======= Contact Section ======= -->
            <section id="contact" class="section-bg">
                <div class="container" data-aos="fade-up">

                    <div class="section-header">
                        <h3>Contact</h3>
<!--                        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque</p>-->
                    </div>

                    <div class="row contact-info">

                        <div class="col-md-4">
                            <div class="contact-address">
                                <i class="ion-ios-location-outline"></i>
                                <h3>Adresse</h3>
                                <address>Ankadindravola Ivato -
                                    105 Antananarivo
                                    Madagascar
                                </address>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="contact-phone">
                                <i class="ion-ios-telephone-outline"></i>
                                <h3>Téléphone</h3>
                                <h3>Whatsapp et Viber</h3>
                                <p><a href="tel:+155895548855">+ 261 32 05 222 17</a></p>
                                <p><a href="tel:+155895548855">+ 261 34 22 222 17</a></p>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="contact-email">
                                <i class="ion-ios-email-outline"></i>
                                <h3>Email</h3>
                                <p><a href="mailto:info@example.com">rado@sunsoft.mg</a></p>
                            </div>
                        </div>

                    </div>

                    <div class="form">
                        <form method="post" role="form" class="php-email-form">
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <input type="text" name="name"
                                           class="form-control"
                                           v-model="formMessage.name"
                                            placeholder="Votre nom"
                                           data-rule="minlen:4"
                                           data-msg="Please enter at least 4 chars" />
                                    <div class="validate"></div>
                                </div>
                                <div class="form-group col-md-6">
                                    <input type="email"
                                           class="form-control"
                                           v-model="formMessage.email"
                                           placeholder="Votre adresse email"
                                           data-rule="email"
                                           data-msg="Please enter a valid email" />
                                    <div class="validate"></div>
                                </div>
                            </div>
                            <div class="form-group">
                                <input type="text"
                                       v-model="formMessage.tel"
                                       class="form-control"
                                       placeholder="Votre numéro de téléphone"/>
                                <div class="validate"></div>
                            </div>
                            <div class="form-group">
                                <input type="text"
                                       v-model="formMessage.subject"
                                       class="form-control"
                                       placeholder="Objet"
                                       data-rule="minlen:4"
                                       data-msg="Please enter at least 8 chars of subject" />
                                <div class="validate"></div>
                            </div>
                            <div class="form-group">
                                <Vueditor ref="editorContainer"></Vueditor>
<!--                                <textarea class="form-control"-->
<!--                                          v-model="formMessage.message"-->
<!--                                          rows="5"-->
<!--                                          data-rule="required"-->
<!--                                          data-msg="Votre message"-->
<!--                                          placeholder="Votre message"></textarea>-->
                                <div class="validate"></div>
                            </div>
                            <div class="mb-3">
                                <div class="loading">Loading</div>
                                <div class="error-message"></div>
                                <div class="sent-message">Your message has been sent. Thank you!</div>
                            </div>

                            <div class="text-center">
                                <mdb-btn outline="success"
                                         v-loading.fullscreen.lock="loading"
                                         @click="send">Envoyer
                                </mdb-btn>
                            </div>
                        </form>
                    </div>

                </div>
            </section><!-- End Contact Section -->
        </main>
    </div>
</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import {mapActions} from 'vuex'
    import { mdbBtn } from 'mdbvue';
    export default {
        name: "index",
        components:{
            mdbBtn
        },
        validations:{
            formMessage:{
                email: {
                    required,
                    validEmail(value){
                        const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
                        return reg.test(value)
                    }
                },
                name:{
                    required
                },
                tel:{
                    required
                },
                subject:{
                    required
                }
            }
        },
        data(){
            return {
                formMessage: {},
                loading: false
            }
        },
        methods:{
            ...mapActions('user',['sendMessageAction']),
            async send(){
                const h = this.$createElement;
                this.$v.$touch()
                // if(!)
                if(this.formMessage.message == ''){
                    this.$notify.warning({
                        title: 'Email',
                        message: h('i', { style: 'color: teal' }, 'Message obligatoire'),
                        duration: 2000
                    });
                    return
                }
                if (this.$v.$invalid) {
                    this.$notify.warning({
                        title: 'Email',
                        message: h('i', { style: 'color: teal' }, 'Champ invalid ou obligatoire'),
                        duration: 2000
                    });
                    return
                }
                let editor = this.$refs.editorContainer
                this.formMessage.message = editor.getContent()
                this.loading = true
               await this.sendMessageAction(this.formMessage)
                this.loading = false
                this.$notify.success({
                    title: 'Message',
                    message: h('i', { style: 'color: teal' }, 'Message envoyé'),
                    duration: 2000
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .img-fluid-service {
        width: 13em;
        height: 13em;
        margin: 0px 73px;
    }

    .vueditor {
        min-height: 300px;
    }
</style>